var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-mini-layout"},[(_vm.loading)?[_c('rotate-square2')]:[_c('app-header'),_c('v-content',[_c('transition',{attrs:{"name":"router-anim","enter-active-class":`animated ${_vm.selectedRouterAnimation}`}},[_c('router-view')],1)],1),_c('app-customizer'),_c('tour')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }